import { render, staticRenderFns } from "./ClaimProgress.vue?vue&type=template&id=0a8a0218&scoped=true"
import script from "./ClaimProgress.vue?vue&type=script&lang=js"
export * from "./ClaimProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a0218",
  null
  
)

export default component.exports